import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { MultiSelectorComponent } from "@components/multi-selector/multi-selector.component";
import { sortBy } from "lodash";
import { Observable, of } from "rxjs";
import { EventService } from "~app/common/services/cqs/event.service";
import { TplDestineringModified, TplEventHandler } from "../../../events/tplEventHandler";
import { IKeyMottagninsplatsFilterValue, ITplArbetsorder, ITplDestinering } from "../../../models/dtos";
import { TplService } from "../../../services/tpl.service";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { IMottagningsplats, ITplDestineringFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-mottagningsplats-filter",
    templateUrl: "./tpl-mottagningsplats-filter.component.html",
    styleUrls: ["./tpl-mottagningsplats-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectorComponent
    ]
})
export class TplMottagningsplatsFilterComponent extends FilterBaseComponent implements OnInit, OnDestroy, ITplDestineringFilter {
    @Input() dataSource: ITplArbetsorder[];

    protected items: Observable<IKeyMottagninsplatsFilterValue[]>;

    private readonly eventHandler: TplEventHandler;
    private readonly eventService = inject(EventService);
    private readonly tplService = inject(TplService);

    constructor() {
        super("mottagningsplats");

        this.eventHandler = new TplEventHandler(this.eventService);
    }

    initMottagningsplatser() {
        const tentativeMottagningsplatser  = this.getMottagningsplatser();
        const resolvedMottagningsplatser  = this.tplService.resolveMottagningsplatsList(tentativeMottagningsplatser);

        const sortedMottagningsplatser = sortBy(resolvedMottagningsplatser, x => x.value);
        this.items = of(sortedMottagningsplatser );

        const currentValue = this.value();
        const valid = currentValue.filter(x => resolvedMottagningsplatser.some(x1 => x1.key === x));
        this.onFilterInit(valid);
    }

    isActive(): boolean {
        return this.value().length > 0;
    }

    match(item: ITplDestinering): boolean {
        const index = this.value().findIndex(x => x === `${item.mottagningsplatsId}/${item.foradlatHandelssortimentId}`);
        return index > -1;
    }

    ngOnDestroy(): void {
        this.eventHandler.unsubscribe();
        super.ngOnDestroy();
    }

    ngOnInit(): void {
        this.eventHandler.onDestineringModified(e => this.onDestineringModified(e));

        this.onFormInit(new UntypedFormControl([]));
        this.initMottagningsplatser();
    }

    onFilterInit(state: string[]): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    value(): string[] {
        return this.control.value;
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addDestineringFilter(this.name, this);
    }

    protected onFormChange(value: number[]): void {
        this.filterLength = value.length;
    }

    private getMottagningsplatser(): IMottagningsplats[] {
        return this.tplService.getMottagningsplatser(this.dataSource, true);
    }

    private onDestineringModified(event: TplDestineringModified): void {
        this.initMottagningsplatser();
    }
}
